import React, { useState } from 'react';

import Loader from 'components/Loader';
import { Field, Form, Formik } from 'formik';
import { useHistory } from 'react-router';
import { addPasswordSchema } from 'utils/validationSchemas';

export const ResetPassword = (props) => {
	const { firebase, actionCode } = props;

	const [loading, setLoading] = useState(false)
	const [error, setError] = useState({})

	const history = useHistory()

	const handlePasswordChange = (values, actions) => {
		setLoading(true)
		firebase
			.verifyPasswordReset(actionCode)
			.then((email) => {
				firebase.confirmResetPassword(actionCode, values.password)
					.then(() => {
						firebase
							.signInWithEmailAndPassword(email, values.password)
							.then(() => {
								history.push('/account')
								setLoading(false)
								actions.setSubmitting(false)
							})
							.catch((err) => setError(err) )
					}).catch((err) => setError(err) )
			})
			.catch(err => {
				setError(err);
			})
		setLoading(false)
		actions.setSubmitting(false)
	}

	return loading ? (
		<Formik
			initialValues= {{
				email: ''
			}}
			validationSchema= {addPasswordSchema}
			onSubmit={handlePasswordChange}
		>
			{({ errors, getFieldProps, handleSubmit, isSubmitting, touched }) => (
				<div className="form-wrapper">
							<div>

								<Form onSubmit={handleSubmit}>

									{touched.password && errors.password ? (<div className="error">{errors.password}</div>) : null}
									<Field required icon='lock' id="password" type="password" placeholder="Add Password" {...getFieldProps('password')} />

									{touched.confirmPassword && errors.confirmPassword && (<span className="error">{errors.confirmPassword}</span>)}
									<Field required id="confirmPassword" type="password" placeholder="Confirm New Password" {...getFieldProps('confirmPassword')} />

									{error && <p className="error">{error.message}</p>}

									<button
										className="w-100 rn-button-style--2 btn-solid"
										disabled={isSubmitting}
										type="submit"
										value="submit"
										name="submit"
										id="mc-embedded-subscribe"
									>
										Reset My Password
									</button>

								</Form>
							</div>
				</div>
			)}
		</Formik>
	) : <Loader />
}

